import type { CachedQueryName } from "../graphql/cachedQueries";
import { stableStringify } from "./stableStringify";

export type CacheMode = "server" | "browser";

// Page prop that carries prefetched data into SWRConfig (see pages/_app.tsx).
export const CACHED_GQL_FALLBACK_PROP_NAME = "__CACHED_GQL_FALLBACK__";

export const CACHE_MODES: CacheMode[] = ["server", "browser"];

// URL of the cached API route; also used as the SWR key.
// `staleWhileRevalidate: false` (browser mode) makes the browser refetch once `ttl` has
// passed, instead of answering from its cache for another `ttl` while it refetches.
export function cachedGqlKey(
  op: CachedQueryName,
  variables: Record<string, unknown> | undefined,
  mode: CacheMode,
  ttl?: number,
  staleWhileRevalidate = true,
) {
  const params = new URLSearchParams({ op });
  const serialized = stableStringify(variables ?? {});
  // `{a: undefined}` and no variables produce the same key.
  if (serialized !== "{}") params.set("v", serialized);
  if (ttl !== undefined) params.set("ttl", String(ttl));
  if (!staleWhileRevalidate) params.set("stale", "0");
  return `/api/${mode}-gql-cache?${params}`;
}
